import AsyncStorage from '@react-native-async-storage/async-storage';

import { createException, ExceptionsTypes } from './utilities/Exceptions';
/**
 * set data to async storage (file in ios , (sqlLite/rockdb) in android )
 * @param  {string} key
 * @param  {any} value
 * @param  {number} expiration
 */
const setData = async (key, value, expiration = 0) => {
  if (!key || !value || isNaN(expiration)) {
    createException(ExceptionsTypes.BadRequest, 'invalid parameters');
  }
  let valueObj = { value, expiration, createdAt: new Date() };
  valueObj = JSON.stringify(valueObj);
  try {
    await AsyncStorage.setItem(key, valueObj);
    return true;
  } catch (error) {
    createException(ExceptionsTypes.UnExpected, 'unexpected error', error);
  }
};
/**
 * get data from async storage
 * @param  {string} key
 */
const getData = async key => {
  try {
    const responseValue = await AsyncStorage.getItem(key);
    if (responseValue !== null) {
      const responseValueJSON = JSON.parse(responseValue);
      const { createdAt, value, expiration } = responseValueJSON;
      if (expiration === 0) {
        return value;
      }
      const expirationTimeDiff = new Date() - new Date(createdAt);
      if (expirationTimeDiff >= expiration * 1000) {
        return false;
      } else {
        return value;
      }
    } else {
      return false;
    }
  } catch (error) {
    createException(ExceptionsTypes.UnExpected, 'unexpected error', error);
  }
};
/**
 * remove data from async storage using key
 * @param  {string} key
 */
const removeKey = async key => {
  try {
    await AsyncStorage.removeItem(key);
  } catch (error) {
    createException(ExceptionsTypes.UnExpected, 'unexpected error', error);
  }
};
export { setData, getData, removeKey };
